<script lang="ts" setup>
const props = defineProps({
	text: {
		type: String,
		required: true,
	},
	action: {
		type: Function,
	},
})

function onClick() {
	if (props.action === undefined) {
		return
	}

	props.action()
}
</script>

<template>
	<div
		class="inline-flex h-[24px] cursor-pointer select-none items-center active:[&_.text]:text-[#f58316]"
		@click="onClick"
	>
		<p
			class="text m-0 p-0 text-[14px] font-bold uppercase leading-[19px] tracking-[1.35px] text-[#ff9e1b] text-[rgba(38,38,38,0.87)]"
		>
			{{ text }}
		</p>
	</div>
</template>
